/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import cx from 'clsx';
import { trackCreativeClick, trackCreativeView } from '@kcd/event-tracker';

import { useIntersectionObserver } from '~/hooks/event';

type Props = {
  children: React.ReactNode;
  adGroupId: number;
  creativeId: number;
  name?: string;
  className?: string;
};

// /placement api를 요청할 떄 래핑하는 컴포넌트 -> 앰플리튜드 이벤트를 보내는데 사용함.
const PlacementRenderer = ({
  children,
  adGroupId,
  creativeId,
  name,
  className,
}: Props) => {
  const viewedCallback = React.useCallback(() => {
    trackCreativeView({
      adGroupId,
      creativeId,
      placementName: name || '',
    });
  }, []);

  const onCreativeClicked = React.useCallback(() => {
    trackCreativeClick({
      adGroupId,
      creativeId,
      placementName: name || '',
    });
  }, []);

  const ref = useIntersectionObserver(viewedCallback);

  return (
    <div
      role="presentation"
      className={cx(className)}
      ref={ref}
      onClick={onCreativeClicked}
    >
      {children}
    </div>
  );
};

export default PlacementRenderer;
